
export enum UserProfileDetailsInput {
    Email,
    Password,
    SavedPaymentMethod,
    NewPaymentMethod,
    PaymentMethod,
    EmailSubscription
}